import { forwardRef, Ref, type SVGProps } from 'react';

const SvgTrendUpIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m22 7-8.5 8.5-5-5L2 17M22 7h-6m6 0v6"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgTrendUpIcon);
export default ForwardRef;
